declare global {
  interface Window {
    lintrk?: (action: string, payload: { conversion_id: number }) => void
  }
}

export function linkedInTrack(conversionId?: number | null) {
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions

  if (window.lintrk && conversionId != null && Number.isInteger(conversionId)) {
    window.lintrk('track', { conversion_id: conversionId })
  }
}
